import Axios from '@/components/api/axios.js'

/**********************************************************************************
 * 灯控
 **********************************************************************************/
export default {
	/**
	 * 获取指定变量本月运行概况
	 * @param {String} variableNames 变量名称,多个用逗号隔开
	 * @param {Long} time 开始时间,以时间戳格式传
	 */
	getEnergyFlowDiagram: (variableNames, time, success, failure) => {
		Axios.post('/light/getEnergyFlowDiagram.do', {
			variableNames,
			time
		}, success, failure)
	},
	/**
	 * 获取指定变量本月日亮灯时长
	 * @param {String} variableNames 变量名称,多个用逗号隔开
	 * @param {Long} time 开始时间,以时间戳格式传
	 */
	getLightTimeForMonth: (variableNames, time, success, failure) => {
		Axios.post('/light/getLightTimeForMonth.do', {
			variableNames,
			time
		}, success, failure)
	},
	/**
	 * 获取单位情景模式树
	 * @param {String} unitId 单位id，不传默认当前登录用户单位
	 */
	getLightSceneTree: (unitId, success, failure) => {
		Axios.post('/light/getLightSceneTree.do', {
			unitId
		}, success, failure)
	},
	/**
	 * 添加或更新情景模式
	 * @param {Long} pkid 情景模式id，传空为添加否为更新
	 * @param {String} name 情景模式名称
	 * @param {String} unitId 所属单位id
	 * @param {int} executionInterval 执行时间间隔,以毫秒为单位
	 * @param {int} deviceNos 关联设备no,多个用逗号隔开
	 */
	saveLightScene: (pkid, name, unitId, executionInterval, deviceNos, success, failure) => {
		Axios.post('/light/saveLightScene.do', {
			pkid,
			name,
			unitId,
			executionInterval,
			deviceNos
		}, success, failure)
	},
	/**
	 * 批量删除指定情景模式以及关联关系
	 * @param {Long} pkids 情景模式id,多个用逗号隔开
	 */
	deleteLightSceneAndRel: (pkids, success, failure) => {
		Axios.post('/light/deleteLightSceneAndRel.do', {
			pkids
		}, success, failure)
	},
	/**
	 * 查询指定变量在指定时间范围内大于某个值的范围
	 * @param {Long} beginTime 开始时间,以时间戳格式传
	 * @param {Long} endTime 结束时间,以时间戳格式传
	 * @param {String} variableNames 变量名称,多个用逗号隔开
	 * @param {double} value 值
	 */
	getRangeForGreaterThanValue(beginTime, endTime, variableNames, value, success, failure) {
		Axios.post('/history/getRangeForGreaterThanValue.do', {
			beginTime,
			endTime,
			variableNames,
			value
		}, success, failure)
	},
	/**
	 * 定时开关指定情景模式
	 * @param {String} type open/close
	 * @param {String} pkids 情景模式id,多个用逗号隔开
	 * @param {Long} time 开始时间,以时间戳格式传，传空默认马上开启或关闭
	 */
	openOrCloseScene: (type, pkids, time, success, failure) => {
		Axios.post('/light/openOrCloseScene.do', {
			type,
			pkids,
			time
		}, success, failure)
	},
	/**
	 * 定时开关指定变量
	 * @param {String} type open/close
	 * @param {String} variableNames 变量名称,多个用逗号隔开
	 * @param {Long} time 开始时间,以时间戳格式传，传空默认马上开启或关闭
	 */
	openOrCloseVariable: (type, variableNames, time, success, failure) => {
		Axios.post('/light/openOrCloseVariable.do', {
			type,
			variableNames,
			time
		}, success, failure)
	},
}